import { ActivityType, EventType, EventVertical, MetaStatus } from '../../meta/meta.types';
import { PagedFilter, GeoLocation } from '../../common/common.types';
import { PriceMatrixSummary } from '../../pricing/price-matrix.types';

export class EventTemplateFilter extends PagedFilter {
	eventVerticalIds?: number[];
	eventTypesIds?: number[];
	statuses?: MetaStatus[];
	searchTerm?: string;
	attendees?: number;
}

export class EventTemplate {
	eventTemplateId: number;
	status: MetaStatus;

	eventVertical?: EventVertical;
	eventType?: EventType;
	priceMatrix?: PriceMatrixSummary;

	minAttendees?: number;
	maxAttendees?: number;
	tags: {
		[tag: string]: number;
	};
	defaultWeighting?: number;
	primaryImagePath: string;
	secondaryImagePath: string;
	primaryImageUrl: string;
	secondaryImageUrl: string;

	name: string;
	tagline: string;
	summary: string;
	description: string;
	inclusions: string;
	locationLabel: string;
	locations?: GeoLocation[];

	activities?: EventTemplateActivity[];
}

export class EventTemplateActivity {
	eventTemplateActivityId: number;
	activityType: ActivityType;
	productId?: number;

	providerName?: string;
	productName?: string;
	name: string;
	summary?: string;

	startDay: number;
	startTime?: string;
	endDay: number;
	endTime?: string;
	isAllDay: boolean;
	isAdminOnly: boolean;
	location?: GeoLocation;
}

export class EventTemplateWM {
	eventVerticalId: number;
	eventTypeId: number;
	priceMatrixId?: number;

	minAttendees?: number;
	maxAttendees?: number;
	tags: {
		[tag: string]: number;
	};

	primaryImagePath: string;
	secondaryImagePath: string;

	name: string;
	tagline: string;
	summary: string;
	description: string;
	inclusions: string;
	locationLabel: string;
	locations?: GeoLocation[];

	activities?: EventTemplateActivityWM[];
}

export class EventTemplateActivityWM {
	activityTypeId: number;
	productId?: number;
	name: string;
	startDay: number;
	startTime?: string;
	endDay: number;
	endTime?: string;
	isAllDay: boolean;
	isAdminOnly: boolean;
	location?: GeoLocation;
}
